import { GO_ARENA_BLACK_COLOR, GO_ARENA_BOARD_AREA, GO_ARENA_NO_KO_MOVE, GO_ARENA_PASS_MOVE, GO_ARENA_WHITE_COLOR } from "../../go-model/web/constants";
import { getAutomaticallyDeadMoves } from "../../go-model/web/game";
import { getMokaGameStateWithoutStones } from "@/utils/get-moka-game-state-without-stones";
const getMokaAutomaticallyScoredGameState = gameState => {
  const boardSize = gameState.board.length;
  const board = new Int8Array(GO_ARENA_BOARD_AREA);
  for (const boardRow of gameState.board) {
    for (const stone of boardRow) {
      if (!stone) {
        continue;
      }
      board[stone.row * boardSize + stone.column] = stone.color === "black" ? GO_ARENA_BLACK_COLOR : GO_ARENA_WHITE_COLOR;
    }
  }
  const arenaGameState = {
    board,
    consecutivePassCount: gameState.consecutivePassCount,
    koMove: gameState.koPoint ? gameState.koPoint.row * boardSize + gameState.koPoint.column : GO_ARENA_NO_KO_MOVE,
    moveCount: gameState.moveCount,
    moveHistory: gameState.moveHistory.map(move => move.coordinate ? move.coordinate.row * boardSize + move.coordinate.column : GO_ARENA_PASS_MOVE),
    nextColor: gameState.nextColor === "black" ? GO_ARENA_BLACK_COLOR : GO_ARENA_WHITE_COLOR
  };
  const deadStoneCoordinates = getAutomaticallyDeadMoves(arenaGameState).map(deadMove => ({
    column: deadMove % boardSize,
    row: Math.floor(deadMove / boardSize)
  }));
  return getMokaGameStateWithoutStones(gameState, deadStoneCoordinates);
};
export { getMokaAutomaticallyScoredGameState };